function contactModel (data) {
    this.sendEmail = data?.sendEmail;
}

export default contactModel;